// extracted by mini-css-extract-plugin
module.exports = {"results":"az_YEb","numberOfResultsContainer":"az_ZEb"};